/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Last_NameInputs */

const cs_field_last_name = /** @type {(inputs: Field_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjmení`)
};

const en_field_last_name = /** @type {(inputs: Field_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Field_Last_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_last_name = /** @type {((inputs?: Field_Last_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Last_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_last_name(inputs)
	return cs_field_last_name(inputs)
});